import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { DialogService } from '../../../services/dialog.service';
import { FileSystemNode } from '../../../model/FileSystemNode';

// todo: evaluar si conviene wrapear el nodo asi o directamente referencio la interface Node
export interface DialogCrearFileDirectorioSelectorComponentData {
  node: FileSystemNode
}

@Component({
  selector: 'app-dialog-crear-file-directorio-selector',
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions
  ],
  templateUrl: './dialog-crear-file-directorio-selector.component.html',
  styleUrl: './dialog-crear-file-directorio-selector.component.scss'
})
export class DialogCrearFileDirectorioSelectorComponent {

  private dialogService = inject(DialogService);

  constructor(
    public dialogRef: MatDialogRef<DialogCrearFileDirectorioSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogCrearFileDirectorioSelectorComponentData
  ) { }

  onCrearArchivo() {
    this.dialogService.agregarFile(this.data.node).subscribe(result => {
      this.dialogRef.close(result);
    });
  }

  onCrearDirectorio() {
    this.dialogService.agregarDirectorio(this.data.node).subscribe(result => {
      this.dialogRef.close(result);
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
